import * as React from "react";
import { Row, Col, Collapse, Icon, Button, message, Tooltip, Tag } from "antd";
import { StyleCargoChargesPanel } from "components/CargoCharges/CargoCharges.Style";
import { result, debounce } from "lodash";
import moment, { Moment } from "moment";
import CargoChargesResultModel, { CargesModel } from "../CargoChargesResultsModel";
import CartContext from "Context/CartContext";
import { SyntheticEvent } from "react";
import { CargoChargeItemHandler } from "./CargoChargeItemHandler";
import { centeredRowAttributes } from "components/Styled/Layout.Styled";
import Column from "antd/lib/table/Column";
import Table, { ColumnProps } from "antd/lib/table";
import Utility from "Core/Utility";
import NotificationUtility from 'Core/NotificationUtility';
import { CartItemChangeDateForm } from "components/CartManagement/CartItemListItem";

export interface Props {
    cargoCharge: CargoChargesResultModel
    children?: React.ReactNode,
    updatePickupDate: (string, Moment) => void;
    removeShipment: (cargo: CargoChargesResultModel) => void;
}

export interface State {
    isInCart: boolean;
}



export default class CargoChargeItem extends React.Component<Props, State> {
    static contextType = CartContext;
    context!: React.ContextType<typeof CartContext>;
    handler: CargoChargeItemHandler;

    constructor(props: Props) {
        super(props)

        this.state = {
            isInCart: false
        }
        this.addToCart = debounce(this.addToCart.bind(this), 1000);
        this.removeFromCart = debounce(this.removeFromCart.bind(this), 1000);
        this.handler = new CargoChargeItemHandler(props);
        this.updateCartItemDate = this.updateCartItemDate.bind(this);
        this.removeShipment = this.removeShipment.bind(this);
    }
    panelColLayout = {
        xs: { span: 24 },
        sm: { span: 24 },
        lg: { span: 24 },
        xl: { span: 24 },
    }

    removeFromCart(event: SyntheticEvent) {
        event.stopPropagation();
        this.handler.RemoveFromCart(this.props.cargoCharge).then(x => {
            this.context.Update(x.cart);
            NotificationUtility.info('Cart Updated', '', 5, true);
        });
    }

    addToCart(event: SyntheticEvent): boolean {
        event.stopPropagation();
        return this.UpsertToCart(this.props.cargoCharge, "Add");
    }

    private UpsertToCart(cargoCharge: CargoChargesResultModel, buttonPressed: string) {
        let isUpdated: boolean = false;
        let total = cargoCharge.total;
        if (Number(total) > 0) {
            this.handler.UpsertToCart(cargoCharge).then(x => {
                this.context.Update(x.cart);
                if (buttonPressed == "Update") {
                    NotificationUtility.info(
                        'Pick-up Date Updated',
                        `Shipment with BOL ${cargoCharge.bolNumber?.toUpperCase()} pick-up date was updated in the cart.`,
                        5,
                        true);
                }
                else {
                    NotificationUtility.success(
                        'Item Added To Cart',
                        `Shipment with BOL ${cargoCharge.bolNumber?.toUpperCase()} was added to the cart.`,
                        5,
                        true);
                }
            });
            isUpdated = true;
        } else {
            NotificationUtility.warning("No Charge", "Shipments with charge of zero cannot be added to the cart", 5, true);
        }

        return isUpdated;
    }

    componentDidMount() {
        if (this.isBolNumberAlreadyInCart()) {
            this.setState({ isInCart: true });
        }
    }

    componentDidUpdate(prevProps: Props, pervState: State) {
        if (this.isBolNumberAlreadyInCart() && !this.state.isInCart) {
            this.setState({ isInCart: true });
        }

        if (!this.isBolNumberAlreadyInCart() && this.state.isInCart) {
            this.setState({ isInCart: false });
        }
    }

    isBolNumberAlreadyInCart() {
        return !!this.context.data?.cartItems?.filter(x => x.itemReference == this.props.cargoCharge.bolNumber).length;
    }

    renderCharges(charges: Array<CargesModel> | undefined) {

        if (!charges) {
            return <></>;
        }

        const chargeTableColums: Array<ColumnProps<CargesModel>> = [
            {
                title: 'Charge',
                dataIndex: 'chargeType',
                key: 'chargeType',
            },
            {
                title: 'Amount',
                dataIndex: 'chargeAmount',
                key: 'chargeAmount',
            },
        ];

        return (
            <Table<CargesModel>
                pagination={charges.length < 3 && false}
                dataSource={charges}
                columns={chargeTableColums}
            />
        );
    }

    updateCartItemDate(newDate: Moment) {
        const updatedCargoCharges = this.props.cargoCharge;
        updatedCargoCharges.storageDueDate = newDate;

        if (this.state.isInCart) {
            this.UpsertToCart(updatedCargoCharges, "Update");
        } else {
            this.props.updatePickupDate(updatedCargoCharges.bolNumber, newDate);
        }

    }
    removeShipment(e: React.FormEvent) {
        e.preventDefault();
        this.props.removeShipment(this.props.cargoCharge);
    }

    render() {
        let result = this.props.cargoCharge;
        return (
            <Row {...centeredRowAttributes} className="react-transition fade-in">
                <Col {...this.panelColLayout} >
                    <Collapse
                        expandIcon={({ isActive }) => (
                            <Icon type="caret-right" rotate={isActive ? 90 : 0} />
                        )}
                        expandIconPosition="left">
                        <StyleCargoChargesPanel
                            header={
                                <>
                                    <Row>
                                        <Col span={8}>
                                            <p>Bill of Lading: <br /> {result.bolNumber?.toUpperCase()}</p>
                                        </Col>
                                        <Col span={7}>
                                            <p>Pickup Date: <br /> {Utility.ToDateString(moment(result.storageDueDate))}</p>
                                        </Col>
                                        <Col span={7}>
                                            <p>Total: <br /> JMD$ {result.total}</p>
                                        </Col>
                                        <Col span={2} />
                                    </Row>
                                    <Row type="flex" style={{ textAlign: "center" }} justify="start">
                                        <Col span={8}>
                                            {
                                                this.state.isInCart ?
                                                    <Tag color="green">In Cart</Tag>
                                                    :
                                                    <Button onClick={(e) => e.stopPropagation() == undefined && this.addToCart(e)}
                                                        style={{ backgroundColor: '#77DD2E', color: 'white' }}>
                                                        Add to Cart
                                                    </Button>
                                            }
                                        </Col>
                                        {this.state.isInCart ? <></> :
                                            <>
                                                <Col span={8}><CartItemChangeDateForm buttonText="Change Pickup Date" buttonSize="default" UpdatedDate={this.updateCartItemDate} /></Col>
                                                <Col span={6}><Tooltip title="Remove from list" ><Icon type="delete" theme="filled" style={{ color: "#FF6232" }} onClick={this.removeShipment} /></Tooltip></Col>
                                            </>

                                        }
                                    </Row>
                                </>

                            }
                            key={result.bolNumber!}>
                            <Row type="flex" justify="space-around">
                                <Col>
                                    <span>Breakdown of Charges</span>
                                </Col>
                            </Row>
                            {this.renderCharges(result.charges)}
                        </StyleCargoChargesPanel>
                    </Collapse>
                </Col>
            </Row>
        )
    }
}
